import "babel-polyfill";
import smoothscroll from 'smoothscroll-polyfill';
import React from "react";
// import ReactDOM from "react-dom";
import "./index.css";
import "./assets/css/style.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import rootReducer from "./store/reducers";
import configureStore from "./store/configureStore";
import { Provider } from "react-redux";
import ReactDOM from 'react-dom/client';

const store = configureStore(rootReducer);

smoothscroll.polyfill();

// ReactDOM.render(
  // <Provider store={store}>
  //   <App />
  // </Provider>,
  // document.getElementById("root")
// );
ReactDOM.createRoot(document.getElementById('root')).render( <Provider store={store}><App /></Provider>);

// root.render(<App />);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();


